/**
 * WOOF Collapsibles
 * Smoothly animates native <details> rows open/closed (height + fade) while
 * keeping semantics and keyboard support. Skipped when the user prefers
 * reduced motion — rows then toggle instantly via default behavior.
 */
const DURATION = 300;
const EASING = 'cubic-bezier(0.4, 0, 0.2, 1)';

class WoofCollapsibles extends HTMLElement {
  connectedCallback() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    this.querySelectorAll('details').forEach((details) => {
      const summary = details.querySelector('summary');
      const content = details.querySelector('.woof-clp__content');
      if (!summary || !content) return;

      summary.addEventListener('click', (event) => {
        event.preventDefault();
        if (details.dataset.animating) return;
        details.dataset.animating = 'true';

        const collapsed = { height: '0px', paddingTop: '0px', paddingBottom: '0px', opacity: 0 };
        const expanded = () => {
          const style = getComputedStyle(content);
          return {
            height: style.height,
            paddingTop: style.paddingTop,
            paddingBottom: style.paddingBottom,
            opacity: 1,
          };
        };

        if (details.open) {
          const animation = content.animate([expanded(), collapsed], { duration: DURATION, easing: EASING });
          animation.onfinish = () => {
            details.open = false;
            delete details.dataset.animating;
          };
        } else {
          details.open = true;
          const animation = content.animate([collapsed, expanded()], { duration: DURATION, easing: EASING });
          animation.onfinish = () => {
            delete details.dataset.animating;
          };
        }
      });
    });
  }
}

if (!customElements.get('woof-collapsibles')) {
  customElements.define('woof-collapsibles', WoofCollapsibles);
}
